/* CraveQuiet lander — document-scoped runtime for the modular Nuralis Cutting Mix PDP.
   Boot-guarded. Synced 1/2/3 supply offers (hero + closing), gallery + zoom, counters,
   comparison selector, and add-to-cart wired straight to the Ascendify cart drawer
   (no preview dialog). Reads the buy box from data attributes — no page-config needed. */
(() => {
  'use strict';
  if (window.__BERBERINE__) return; window.__BERBERINE__ = true;

  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;

  const boot = () => {
    let selected = 2, gallery = 0;

    /* ---------- offers (hero + closing kept in sync) ---------- */
    const packs = $$('[data-pack-input]');
    function unitWord(n) { return n === 1 ? 'bottle' : 'bottles'; }
    function select(q) {
      selected = q;
      packs.forEach(e => {
        const on = +e.dataset.count === q;
        e.checked = on;
        const lab = e.closest('.tier'); if (lab) lab.classList.toggle('on', on);
      });
      const cur = packs.find(e => +e.dataset.count === q) || packs[0];
      const total = cur ? (cur.dataset.total || '') : '';
      $$('.selection').forEach(el => { el.textContent = `${total} total · ${q} ${unitWord(q)} · ${q * 30}-day supply`; });
    }
    packs.forEach(e => e.addEventListener('change', () => select(+e.dataset.count)));

    /* ---------- gallery ---------- */
    const slides = $$('.gallery-slide');
    function slide(i) {
      if (!slides.length) return;
      gallery = (i + slides.length) % slides.length;
      slides.forEach((e, j) => e.classList.toggle('active', j === gallery));
      $$('.thumb').forEach((e, j) => { e.classList.toggle('on', j === gallery); e.setAttribute('aria-pressed', String(j === gallery)); });
    }
    $$('.thumb').forEach(e => e.onclick = () => slide(+e.dataset.index));
    $('.gallery-prev') && ($('.gallery-prev').onclick = () => slide(gallery - 1));
    $('.gallery-next') && ($('.gallery-next').onclick = () => slide(gallery + 1));
    const stage = $('.gallery-stage');
    function zoom() { const d = $('.zoom-dialog'); if (!d) return; const a = $('.gallery-slide.active img'); if (a) { const im = $('img', d); im.src = a.src; im.alt = a.alt; } d.showModal && d.showModal(); }
    stage && (stage.onclick = zoom);
    $('.gallery-zoom') && ($('.gallery-zoom').onclick = zoom);
    stage && stage.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); slide(gallery + (e.key === 'ArrowRight' ? 1 : -1)); }
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); zoom(); }
    });
    if (stage) {
      let tx = null;
      stage.addEventListener('touchstart', e => tx = e.touches[0].clientX, { passive: true });
      stage.addEventListener('touchend', e => { if (tx == null) return; const dx = e.changedTouches[0].clientX - tx; if (Math.abs(dx) > 45) slide(gallery + (dx < 0 ? 1 : -1)); tx = null; }, { passive: true });
    }

    /* ---------- dialogs ---------- */
    $$('dialog').forEach(d => {
      const c = $('.dialog-close', d); c && (c.onclick = () => d.close());
      d.addEventListener('click', e => { if (e.target === d) { const r = d.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close(); } });
    });
    $$('.label-open').forEach(b => b.onclick = () => { const d = $('.label-dialog'); d && d.showModal(); });
    $('.print-label') && ($('.print-label').onclick = () => print());

    /* ---------- add to cart → Ascendify drawer ---------- */
    const SECTIONS = 'cart-drawer,cart-icon-bubble';
    function openDrawer() {
      const d = document.querySelector('cart-drawer');
      if (d) { d.classList.remove('is-empty'); if (typeof d.open === 'function') { try { d.open(); return true; } catch (e) {} } d.classList.add('active', 'animate'); d.setAttribute('open', ''); document.body.classList.add('overflow-hidden'); return true; }
      const n = document.querySelector('cart-notification'); if (n && typeof n.open === 'function') { try { n.open(); return true; } catch (e) {} }
      return false;
    }
    async function refreshDrawer() {
      try {
        const data = await (await fetch(ROOT + '?sections=' + SECTIONS, { headers: { Accept: 'application/json' } })).json();
        if (data['cart-drawer']) { const t = document.createElement('div'); t.innerHTML = data['cart-drawer']; const fresh = t.querySelector('cart-drawer'); const live = document.querySelector('cart-drawer'); if (fresh && live) live.innerHTML = fresh.innerHTML; }
        if (data['cart-icon-bubble']) { const b = document.getElementById('cart-icon-bubble'); if (b) { const t = document.createElement('div'); t.innerHTML = data['cart-icon-bubble']; const fresh = t.querySelector('#cart-icon-bubble') || t.firstElementChild; if (fresh) b.innerHTML = fresh.innerHTML; } }
      } catch (e) {}
    }
    function selectedInput() { return packs.find(e => e.checked) || packs.find(e => +e.dataset.count === selected) || packs[0]; }
    function subscribePlan() {
      const sub = $$('[data-sub-input]').find(e => e.checked);
      if (sub && sub.value === 'subscribe') { const el = $('[data-selling-plan]'); return el ? el.getAttribute('data-selling-plan') : null; }
      return null;
    }
    let busy = false;
    $$('.purchase').forEach(b => b.addEventListener('click', async () => {
      const inp = selectedInput();
      const vid = inp && inp.dataset.variantId;
      if (!vid || !/^\d+$/.test(vid)) { location.assign(ROOT + 'cart'); return; }
      if (busy) return; busy = true;
      const orig = b.textContent; b.disabled = true; b.textContent = 'Adding…';
      const item = { id: Number(vid), quantity: 1 };
      const plan = subscribePlan(); if (plan && /^\d+$/.test(plan)) item.selling_plan = Number(plan);
      try {
        const r = await fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) });
        const res = await r.json(); if (!r.ok) throw new Error(res.description || 'add failed');
        await refreshDrawer(); syncCartCount();
        if (!openDrawer()) { location.assign(ROOT + 'cart'); return; }
        b.disabled = false; b.textContent = orig; busy = false;
      } catch (e) { b.textContent = 'Please try again'; busy = false; setTimeout(() => { b.textContent = orig; b.disabled = false; }, 2500); }
    }));

    /* ---------- header cart bag + live badge ---------- */
    function setCount(n) { $$('[data-np-cart-count]').forEach(el => { el.textContent = n; if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', ''); }); }
    async function syncCartCount() { try { const c = await (await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })).json(); setCount(c.item_count || 0); } catch (e) {} }
    $$('[data-cart-bag]').forEach(a => a.addEventListener('click', async e => { e.preventDefault(); await refreshDrawer(); if (!openDrawer()) location.assign(ROOT + 'cart'); }));
    if (!window.fetch.__brbPatched) {
      const _fetch = window.fetch.bind(window);
      window.fetch = function (...a) { const p = _fetch(...a); try { const u = (a[0] && a[0].url) || a[0] || ''; if (/\/cart\/(add|change|update|clear)/.test(String(u))) p.then(() => syncCartCount()).catch(() => {}); } catch (e) {} return p; };
      window.fetch.__brbPatched = true;
    }
    ['cart:refresh', 'cart:change', 'cart:updated', 'ajaxCart:afterCartLoad'].forEach(ev => document.addEventListener(ev, syncCartCount));
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && 'MutationObserver' in window) new MutationObserver(() => syncCartCount()).observe(bubble, { childList: true, subtree: true });

    /* ---------- counters ---------- */
    const nums = $('.nums');
    if (nums && 'IntersectionObserver' in window) {
      let counted = false;
      new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting || counted) return; counted = true;
        $$('[data-count]', nums).forEach((el, i) => {
          const target = +el.dataset.count;
          if (reduce || target === 0) { el.textContent = target; return; }
          let start; const duration = [0, 500, 1000, 1800][i] || 1200;
          function tick(t) { start ??= t; const p = Math.min((t - start) / duration, 1); el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(tick); }
          requestAnimationFrame(tick);
        });
      }, { threshold: .4 }).observe(nums);
    }

    /* ---------- comparison selector ---------- */
    const cs = $('.compare-selector select'), mc = $('.multi-compare');
    cs && mc && cs.addEventListener('change', () => mc.dataset.show = cs.value);

    /* ---------- sticky bar (fallback CTA) ---------- */
    const sticky = $('.sticky');
    if (sticky && 'IntersectionObserver' in window) {
      const ctas = $$('.purchase, .navcta, [data-buy]').filter(e => !sticky.contains(e));
      let onscreen = new Set();
      const io = new IntersectionObserver(es => {
        es.forEach(e => { if (e.isIntersecting) onscreen.add(e.target); else onscreen.delete(e.target); });
        sticky.hidden = onscreen.size > 0 || scrollY < innerHeight * 0.6;
      }, { threshold: 0 });
      ctas.forEach(c => io.observe(c));
      addEventListener('scroll', () => { sticky.hidden = onscreen.size > 0 || scrollY < innerHeight * 0.6; }, { passive: true });
    }

    select(2); slide(0); syncCartCount();
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
})();
